import { createAvailabilitySlotsService } from '@shared/api/availability-slots.service'
import { authorizedHttpClient } from './http-client'

export const AvailabilitySlotsService = createAvailabilitySlotsService(
  authorizedHttpClient,
  import.meta.env.VITE_API_URL,
)
